// TODO: Temporarily hidden — confirm with Payments team before re-enabling Pay Later.
// Restore when backend has re-enabled Pay Later for all eligible rate types.
// Contact: Sean Novis (Payments team)
// Slack context: https://luxgroup-hq.slack.com/archives/C06PT0KPZ5L/p1767656827122429?thread_ts=1766063198.377459&cid=C06PT0KPZ5L
// import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
// import Pill from 'LuxKit/Pill'
// import { useIntl } from 'react-intl'

function PayLaterPill() {
  return null
  // const intl = useIntl()
  // return (
  //   <Pill startIcon={<LineClockDollarIcon />}>
  //     {intl.formatMessage({
  //       id: 'Vn7AKo7XW91K3Y8LCerG',
  //       defaultMessage: 'Pay later',
  //       description: 'Label on offer rate cards indicating the customer can defer payment until later',
  //     })}
  //   </Pill>
  // )
}

export default PayLaterPill
